import React from 'react'
import Tag from './Tag'

const TagList = props => {
  return (
    <div className="tags">
      {props.tags.map(tag => <Tag key={tag.text} text={tag.text} isClickable={tag.isClickable} onClick={tag.onClick} />)}
    </div>
  )
}

export default TagList



// WEBPACK FOOTER //
// ./src/components/generic/TagList.js